import React, { useState } from "react"
import ClientReportContent from "./controllers/ClientReportContent.controller"
import ClientReportHeader from "./controllers/ClientReportHeader.controller"
import {
  getMondayOfCurrentWeek,
  getSundayOfCurrentWeek,
} from "../../utils/date.utils"
import ModalFormGroupClientSprints from "./controllers/ModalFormGroupClientSprints.controller"
import useClientReportPeriods from "./hooks/useClientReportPeriods.hook"
import useReportFiltersContext from "../../hooks/contextConsumers/useReportFiltersContext.hook"
import { UNIFIEDDATE_VALUES } from "../../consts/CompoundRangeDatePicker"
import useClientReportPdfData from "./hooks/useClientReportPdfData.hook"

const ClientReport = () => {
  const [selectedPeriod, setSelectedPeriod] = useState({})
  const [refresh, setRefresh] = useState(false)
  const triggerRefresh = () => {
    setRefresh((prev) => !prev)
  }
  const [dateRange, setDateRange] = useState([
    getMondayOfCurrentWeek(),
    getSundayOfCurrentWeek(),
  ])
  const [clientHasValidSprint, setClientHasValidSprint] = useState(false)
  const { clientReportSelectedClient } = useReportFiltersContext()
  const { sprintBlocks, sprintCycles } = useClientReportPeriods({
    clientId: clientReportSelectedClient,
    refresh,
  })

  const [visibleMap, setVisibleMap] = useState({
    SUMMARY: true,
    POINT_PROGRESS: true,

    BURNCHART: true,
    HORIZON_ESTIMATION: true,
    BUDGET_STATE: true,
    NOTES: true,
  })

  const [
    isModalGroupClientSprintsVisible,
    setIsModalGroupClientSprintsVisible,
  ] = useState(false)

  const [clientSprints, setClientSprints] = useState([])

  const [period, setPeriod] = useState(UNIFIEDDATE_VALUES.SPRINT)
  const {
    data: pdfExtraData,
    loading: pdfExtraDataLoading,
    error: pdfExtraDataError,
  } = useClientReportPdfData({
    periodId: selectedPeriod?.id,
    clientId: selectedPeriod?.clientId,
    periodType: period,
  })

  return (
    <>
      <ModalFormGroupClientSprints
        isModalGroupClientSprintsVisible={isModalGroupClientSprintsVisible}
        setIsModalGroupClientSprintsVisible={
          setIsModalGroupClientSprintsVisible
        }
        clientSprints={clientSprints}
        clientId={clientReportSelectedClient}
        triggerRefresh={triggerRefresh}
        sprintBlocks={sprintBlocks}
      />
      <ClientReportHeader
        selectedPeriod={selectedPeriod}
        visibleMap={visibleMap}
        setIsModalGroupClientSprintsVisible={
          setIsModalGroupClientSprintsVisible
        }
        period={period}
      />
      <ClientReportContent
        selectedPeriod={selectedPeriod}
        setSelectedPeriod={setSelectedPeriod}
        refresh={refresh}
        setRefresh={setRefresh}
        triggerRefresh={triggerRefresh}
        dateRange={dateRange}
        setDateRange={setDateRange}
        visibleMap={visibleMap}
        setVisibleMap={setVisibleMap}
        clientHasValidSprint={clientHasValidSprint}
        setClientHasValidSprint={setClientHasValidSprint}
        clientSprints={clientSprints}
        setClientSprints={setClientSprints}
        sprintBlocks={sprintBlocks}
        sprintCycles={sprintCycles}
        period={period}
        setPeriod={setPeriod}
        extraData={pdfExtraData}
      />
    </>
  )
}

export default ClientReport
